"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RoadworksIcon = RoadworksIcon;
var _SvgIcon2 = _interopRequireDefault(require("@mui/material/SvgIcon"));
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function RoadworksIcon(props) {
  return /*#__PURE__*/_react.default.createElement(_SvgIcon2.default, _extends({
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/_react.default.createElement("path", {
    d: "M13.9759 4.58683C13.8436 4.23351 13.5067 4 13.1291 4H10.8711C10.4936 4 10.1566 4.23351 10.0243 4.58683L6.18108 17.1955H5.90226C5.40396 17.1955 5 17.5994 5 18.0977C5 18.596 5.40396 19 5.90226 19H18.0977C18.596 19 19 18.596 19 18.0977C19 17.5994 18.596 17.1955 18.0977 17.1955H17.8189L13.9759 4.58683ZM14.536 12.797H9.46419L10.1416 10.203H13.8586L14.536 12.797ZM11.4965 5.80443H12.5038L13.1812 8.39843H10.819L11.4965 5.80443ZM8.78677 14.6015H15.2135L15.8909 17.1955H8.10936L8.78677 14.6015Z",
    fill: "currentColor"
  }));
}